export function getOutcomeImage(outcome) {
  switch (outcome.name) {
    case "Carbon Emissions":
      return "/statics/outcomes/Carbon - Full Colour.svg";
    case "Waste Management":
      return "/statics/outcomes/Waste - Full Colour.svg";
    case "Energy Management":
      return "/statics/outcomes/Energy - Full Colour.svg";
    case "Water":
      return "/statics/outcomes/Water - Full Colour.svg";
    case "Use SME's":
      return "/statics/outcomes/SME - Full Colour.svg";
    case "Use Local":
      return "/statics/outcomes/Using Local - Full Colour.svg";
    case "Charitable":
      return "/statics/outcomes/NFP - Full Colour.svg";
    case "Social Procurement":
      return "/statics/outcomes/Social Enterprise - Full Colour.svg";
    case "Eco Systems":
      return "/statics/outcomes/Eco - Full Colour.svg";
    case "Cultural":
      return "/statics/outcomes/Cultural - Full Colour.svg";
    case "Responsible Supply Chain":
      return "/statics/outcomes/Responsible Supply Chain - Full Colour.svg";
    case "Health & Wellbeing":
      return "/statics/outcomes/Health & Wellbeing - Full Colour.svg";
    // case "Training & Development":
    //   return "/statics/outcomes/Training & Development - Full Colour.svg";
    case "Diversity, Equity & Inclusion":
      return "/statics/outcomes/Diversity - Full Colour.svg";
    case "Sustainability Leadership":
      return "/statics/outcomes/Intentional Leadership - Full Colour.svg";
    case "Sustainability Innovation":
      return "/statics/outcomes/Innovation - Full Colour.svg";
    case "Training & Development":
      return "/statics/outcomes/Employment Opp - Full Colour.svg";
    default:
      return "";
  }
}
